/* Laimes rato dovanos — pridejimas i krepseli vienu paspaudimu.
 *
 * Problema: Shopify BXGY nuolaida pati nieko i krepseli nededa. Ji tik padaro
 * nemokama ta preke, kuria pirkejas jau isidejo. Laimejes „dirzeli dovanu"
 * zmogus apie tai nezino, nieko nededa ir dovanos negauna.
 *
 * Sprendimas: skaitom pritaikyta nuolaidos koda is /cart.js (laukas
 * discount_codes) ir krepselyje parodom juosta su mygtuku. Omnisendo nieko
 * neklausiam — jis nuolaidos kodo i nuorodas iterpti neleidzia, o kodas i
 * krepseli patenka pacziam pirkejui ji ivedus.
 *
 * Tylus pridejimas butu rizikingas: jei nuolaida nepritaikoma (pvz. krepselyje
 * nera drono), zmogus sumoketu uz neprasyta preke. Todel pridedam tik
 * paspaudus, o po pridejimo dar PATIKRINAM realia eilutes kaina — jei dovana
 * neisejo nemokama, preke is karto pasalinam ir pasakom kodel.
 *
 * Del to skriptui nereikia zinoti, kurios prekes priklauso „Dronai"/„Rinkiniai"
 * kolekcijoms — sprendima priima pats Shopify, mes tik perskaitom rezultata.
 */
(function () {
  "use strict";

  /* riba — kiek centais eilute gali kainuoti PO nuolaidos. Dovanoms 0,
     pradziamoksliui 2900 (69 € -> 29 €). */
  var DOVANOS = {
    RATAS29: {
      pav: "Pradžiamokslis už 29 €",
      variantas: 56748685164889,
      kiekis: 1,
      riba: 2900
    },
    DIRZELIS: {
      pav: "Dirželis dovanų",
      variantas: 58108883698009,
      kiekis: 1,
      riba: 0
    },
    VARZTAI: {
      pav: "20 varžtų dovanų",
      variantas: 56585998238041, /* M3 14 mm */
      kiekis: 20,
      riba: 0
    },
    /* Propeleriu negalim parinkti uz zmogu — nuolaida galioja visai kolekcijai,
       o antras nemokamas tik tada, kai pirmas jau pasirinktas. Todel ne mygtukas,
       o nuoroda. */
    PROPELERIAI21: {
      pav: "Propeleriai 2 už 1",
      nuoroda: "/collections/propeleriai",
      nuorodosTekstas: "Rinktis propelerius"
    }
  };

  var ZYME = "dm-dovana";
  var SALYGA = "Galioja perkant droną arba rinkinį.";

  /* Kur kabinam juosta: krepselio puslapyje ir krepselio stalciuje. */
  var TAIKINIAI = [".cart__footer--buttons", ".drawer__footer-buttons"];

  function paimta(kodas) {
    try { return localStorage.getItem(ZYME + "-" + kodas) === "1"; }
    catch (e) { return false; }
  }

  function zymetiPaimta(kodas) {
    try { localStorage.setItem(ZYME + "-" + kodas, "1"); } catch (e) {}
  }

  function krepselis() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); });
  }

  function siusti(kelias, kunas) {
    return fetch(kelias, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(kunas)
    }).then(function (r) { return r.json(); });
  }

  /* Kuri dovana laukia: kodas pritaikytas, bet dar nepaimta. */
  function rastiDovana(cart) {
    var kodai = (cart.discount_codes || []).map(function (d) {
      return String(d.code || "").toUpperCase();
    });
    for (var kodas in DOVANOS) {
      if (kodai.indexOf(kodas) !== -1 && !paimta(kodas)) {
        return { kodas: kodas, d: DOVANOS[kodas] };
      }
    }
    return null;
  }

  function eilute(cart, variantas) {
    var rastos = (cart.items || []).filter(function (i) {
      return i.variant_id === variantas;
    });
    return rastos[0] || null;
  }

  /* Prideda ir patikrina. Jei eilute nepatiginejo iki ribos — grazina atgal.
     bazė = kiek ta eilute kainavo PRIES pridejima (zmogus galejo tu pacziu
     varztu jau turet, uz juos jis moka kaip ir mokejo). */
  function pridetiDovana(d) {
    var baze = 0;
    return krepselis()
      .then(function (cart) {
        var buvo = eilute(cart, d.variantas);
        baze = buvo ? buvo.final_line_price : 0;
        return siusti("/cart/add.js", {
          items: [{ id: d.variantas, quantity: d.kiekis }]
        });
      })
      .then(krepselis)
      .then(function (cart) {
        var dabar = eilute(cart, d.variantas);
        if (!dabar) return { ok: false, kodel: "neprideta" };
        if (dabar.final_line_price > baze + d.riba) {
          return siusti("/cart/change.js", { id: dabar.key, quantity: 0 })
            .then(function () { return { ok: false, kodel: "netaikoma" }; });
        }
        return { ok: true };
      });
  }

  function elementas(zyme, klase, tekstas) {
    var el = document.createElement(zyme);
    if (klase) el.className = klase;
    if (tekstas) el.textContent = tekstas;
    return el;
  }

  function juosta(dovana) {
    var d = dovana.d;

    var sakn = elementas("div", "dm-dovana");
    sakn.setAttribute("data-dm-dovana", dovana.kodas);

    var kair = elementas("div", "dm-dovana__tekstas");
    kair.appendChild(elementas("strong", null, "Laimėjai: " + d.pav));
    var sal = elementas("span", "dm-dovana__salyga", SALYGA);
    kair.appendChild(sal);
    sakn.appendChild(kair);

    if (d.nuoroda) {
      var a = elementas("a", "dm-dovana__mygtukas", d.nuorodosTekstas);
      a.href = d.nuoroda;
      sakn.appendChild(a);
      return sakn;
    }

    var mygt = elementas("button", "dm-dovana__mygtukas", "Pridėti");
    mygt.type = "button";
    mygt.addEventListener("click", function () {
      mygt.disabled = true;
      mygt.textContent = "Dedama…";
      pridetiDovana(d).then(function (r) {
        if (r.ok) {
          zymetiPaimta(dovana.kodas);
          window.location.reload();
          return;
        }
        mygt.remove();
        sal.textContent = r.kodel === "netaikoma"
          ? "Dovana galioja tik perkant droną arba rinkinį — į krepšelį nieko nepridėjome."
          : "Nepavyko pridėti. Parašykite mums ir sutvarkysime.";
        sakn.classList.add("dm-dovana--klaida");
      });
    });
    sakn.appendChild(mygt);
    return sakn;
  }

  function nuvalyti() {
    var seni = document.querySelectorAll("[data-dm-dovana]");
    for (var i = 0; i < seni.length; i++) seni[i].remove();
  }

  function piesti(dovana) {
    for (var i = 0; i < TAIKINIAI.length; i++) {
      var vieta = document.querySelector(TAIKINIAI[i]);
      /* Krepselio stalcius buna dokumente ir uzdarytas — tai nieko netrukdo,
         juosta tiesiog laukia kartu su visu stalciumi. */
      if (vieta && vieta.parentNode) {
        vieta.parentNode.insertBefore(juosta(dovana), vieta);
      }
    }
  }

  function atnaujinti() {
    krepselis().then(function (cart) {
      nuvalyti();
      if (!cart.items || !cart.items.length) return;
      var dovana = rastiDovana(cart);
      if (dovana) piesti(dovana);
    }).catch(function () { /* krepselio nera — nieko nerodom */ });
  }

  /* Tema krepseli perpiesia savo AJAX'u, todel po kiekvienos /cart/ uzklausos
     juosta reikia atstatyti. Perrasom fetch'a, nes temos ivykiai skirtingose
     vietose vadinasi skirtingai. */
  var originalusFetch = window.fetch;
  window.fetch = function () {
    var atsakas = originalusFetch.apply(this, arguments);
    try {
      var a = arguments[0];
      var url = String((a && a.url) || a || "");
      if (url.indexOf("/cart/") !== -1 && url.indexOf("/cart.js") === -1) {
        atsakas.then(function () { setTimeout(atnaujinti, 400); });
      }
    } catch (e) {}
    return atsakas;
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", atnaujinti);
  } else {
    atnaujinti();
  }
})();
